import React from 'react';

// Material UI Components
import {Button} from '@material-ui/core';

// Icons
import NotInterestedRoundedIcon from '@material-ui/icons/NotInterestedRounded';
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';

export default function Highlighter( {StyleButton, currentSelectionOffset, contentBlock, onClickToggleStyle} ) {
    const highlighterColors = ["TRANSPARENT", "#34495E", "#95A5A6", "#E74C3C", "#E67E22","#9B59B6", "#3498DB", "#2ECC71", "#1ABC9C"];
    const stylesArray = [...contentBlock.getInlineStyleAt(currentSelectionOffset)]

    let [highlighterActive, setHighlighterActive] = React.useState('TRANSPARENT');

    React.useEffect(() => {
        highlighterColors.forEach(font => {
            const highlighterColor = stylesArray.find(style => style === font) || "";

            switch(highlighterColor){
                case "TRANSPARENT":
                    setHighlighterActive("TRANSPARENT");
                    break;
                case "#34495E":
                    setHighlighterActive("#34495E");
                    break;
                case "#95A5A6":
                    setHighlighterActive("#95A5A6");
                    break;
                case "#E74C3C":
                    setHighlighterActive("#E74C3C");
                    break;
                case "#E67E22":
                    setHighlighterActive("#E67E22");
                    break;
                case "#9B59B6":
                    setHighlighterActive("#9B59B6");
                    break;
                case "#3498DB":
                    setHighlighterActive("#3498DB");
                    break;
                case "#2ECC71":
                    setHighlighterActive("#2ECC71");
                    break;
                case "#1ABC9C":
                    setHighlighterActive("#1ABC9C");
                    break;
                default:
                    break;
            }
        });
    }, [highlighterColors, stylesArray])

    return (
        <React.Fragment>
            {
                highlighterColors.map((item, index) => {
                    // const checkItem = item === "TRANSPARENT" ? "#000000" : item 
                    return(

                        <div key={index} onMouseDown={(event) => {
                            event.preventDefault();
                            onClickToggleStyle(item)
            
                        }}>
                            <Button 
                                aria-label={item === "TRANSPARENT" ? `highlighter color transparent` : `highlighter color hex: #${item}`} 
                                className={StyleButton} 
                                color={(highlighterActive === item) ? "primary" : "inherit"} 
                                size="small"
                                style={{maxWidth: "34px", minWidth: "0", margin: "0"}}
                                variant={(highlighterActive === item) ? "contained" : "text"}>
                                    {
                                        item === "TRANSPARENT" ? <NotInterestedRoundedIcon style={{color: "inherit"}} /> : <FiberManualRecordRoundedIcon style={{color: item}} />
                                    }
                            </Button  >
                        </div>
                    );
                })
            }
        </React.Fragment>
    )
}